import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AcListComponent} from './ac-list.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule
    ],
    declarations: [
        AcListComponent,
    ],
    entryComponents: [
        AcListComponent,
    ],
    exports: [
        AcListComponent,
    ]
})
export class AcListModule {
}
